import type BrandingData from '../../interfaces/BrandingData';
import { useAppStore } from '../../store/store';

export const DEFAULT_DOCUMENT_BRAND = 'Filegrant Enterprise';

/** Brand segment for document.title from branding store (no DOM writes). */
export function resolveBrand(brandingData?: BrandingData | null): string {
  const name = brandingData?.companyName?.trim();
  if (!name) return DEFAULT_DOCUMENT_BRAND;
  return `Filegrant ${name}`;
}

/** Sync read from zustand (tests / non-React callers). */
export function resolveBrandFromStore(): string {
  return resolveBrand(useAppStore.getState().brandingData);
}
